export default __webpack_public_path__ + "static/media/dich_vu_thue_xe_tu_lai_hanoi.f177339e.svg";